import React from 'react';
const REPEAT = 8;
export function StickyAlertBar() {
  return <div className="fixed top-0 left-0 w-full z-50 py-2.5 overflow-hidden" style={{
    background: 'linear-gradient(90deg, #EFE7D8 0%, #F6F1E7 50%, #EFE7D8 100%)',
    borderBottom: '1px solid rgba(200,169,106,0.55)'
  }} data-id="element-265">
      {/* Double the items so the second half is identical — seamless loop */}
      <div className="animate-marquee-fast whitespace-nowrap flex items-center" data-id="element-266">
        {[...Array(REPEAT)].map((_, i) => <span key={i} className="mx-7 tracking-widest uppercase font-bold text-sm md:text-base flex-shrink-0" style={{
        color: '#9A7030'
      }} data-id="element-267">
            🎁 SOLO POR HOY 7 BONOS DE REGALO 🎁
          </span>)}
      </div>
    </div>;
}